var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0001 4H5.00006C4.20441 4 3.44135 4.31607 2.87874 4.87868C2.31613 5.44129 2.00006 6.20435 2.00006 7V17C2.00006 17.7956 2.31613 18.5587 2.87874 19.1213C3.44135 19.6839 4.20441 20 5.00006 20H19.0001C19.7957 20 20.5588 19.6839 21.1214 19.1213C21.684 18.5587 22.0001 17.7956 22.0001 17V7C22.0001 6.20435 21.684 5.44129 21.1214 4.87868C20.5588 4.31607 19.7957 4 19.0001 4ZM18.5901 6L12.7101 11.88C12.6171 11.9737 12.5065 12.0481 12.3846 12.0989C12.2628 12.1497 12.1321 12.1758 12.0001 12.1758C11.868 12.1758 11.7373 12.1497 11.6155 12.0989C11.4936 12.0481 11.383 11.9737 11.2901 11.88L5.41006 6H18.5901ZM20.0001 17C20.0001 17.2652 19.8947 17.5196 19.7072 17.7071C19.5196 17.8946 19.2653 18 19.0001 18H5.00006C4.73484 18 4.48049 17.8946 4.29295 17.7071C4.10542 17.5196 4.00006 17.2652 4.00006 17V7.41L9.88006 13.29C10.4426 13.8518 11.2051 14.1674 12.0001 14.1674C12.7951 14.1674 13.5576 13.8518 14.1201 13.29L20.0001 7.41V17Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailOutline);
export default __webpack_public_path__ + "static/media/email_outline.44ec1729906e601ef4fe5fee9e3f8b73.svg";
export { ForwardRef as ReactComponent };